<template>
  <div class="module_page page_content institution" aria-label="My Institutions page">

    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-5 right-container"></div>
    </div>

    <div class="page_content_container">

      <institution-menu-new :uuid="uuid" :active="'landingPages'"></institution-menu-new>

      <div class="row pg_content">
        <div class="col-12">
          <b-jumbotron style="padding-top: 10px;">
            <!-- Self Signup Page  Config -->
            <div class="row plan_row">
              <div class="col-6 ace_sec_txt title">
                Self Signup Page Configuration
              </div>

              <div class="col-6 btn_container">
                <b-button class="btn" aria-label="Config" @click="navigateToSelfSignupConfig">Config</b-button>
              </div>
            </div>
            <!-- Self Signup Page  Config  Ends -->
          </b-jumbotron>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenuNew from './InstitutionMenuNew'
import InstitutionHeader from './InstitutionHeader'

export default {
  name: 'LandingPages',
  props: ['uuid'],
  components: {
    InstitutionMenuNew,
    InstitutionHeader
  },
  data: () => {
    return {
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [ 10, 50, 100 ],
      filter: '',
      institutions: [],
      shouldShowNoResultFound: false,
      fields: [
        {key: 'name', label: 'Institution Name', class: 'first-column', thClass: 'text-center'}
      ]
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadAllUserInstitution',
      'setUserInfo',
      'loadChangeUserInstitution'
    ]),
    loadInstitution () {
      this.loadInstitutionDetail(this.uuid)
      this.populateInstitutions()
    },
    populateInstitutions () {
      this.loadAllUserInstitution().then(resp => {
        this.institutions = resp
        this.totalRows = this.institutions.length
      })
    },
    navigateToSelfSignupConfig () {
      return this.$router.push({ name: 'selfRegistrationConfiguration', params: { uuid: this.uuid } })
    },
    navigateToDashboard (userRole) {
      let role = userRole.toLowerCase()
      let url = '/user/track/' + role
      if ((role === 'instructor & admin') || (role === 'curator')) {
        url = '/user/track/admin'
      } else if (role === 'employer admin') {
        url = '/employer/admin'
      } else if (role === 'prospective student' || role === 'admitted student') {
        url = '/user/track/' + role.split(' ').join('_')
      } else if (role === 'widget admin') {
        url = '/user/track/' + role.split(' ').join('_')
      }
      this.$router.push(url)
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    changeInstitution (institution) {
      this.loadChangeUserInstitution(institution.uuid).then(res => {
        this.$store.commit('LOAD_ALL_CHANNELS', [])
        this.$store.commit('LOAD_LEARNING_SPACES', [])
        let status = res.status
        let userObj = res.data
        if (status === 200) {
          this.setUserInfo(userObj)
          let userRole = userObj.roles[0].role
          let role = userRole.toLowerCase()
          this.navigateToDashboard(role)
        }
      })
    },
    addStyleClass (item) {
      if (this.uuid === item.uuid) {
        return 'current-institution'
      }
      return 'other-institution'
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
      if (filteredItems.length === 0) {
        this.shouldShowNoResultFound = true
      } else {
        this.shouldShowNoResultFound = false
      }
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution
    })
  }
}
</script>

<style>
  .other-institution {
    color: #157099;
    cursor: pointer;
  }
  .current-institution {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/LandingPages.vue